<template>
  <v-card id="clock-exterior" class="overflow-hidden" elevation="6">
    <div id="clock-background" class="d-flex align-center justify-center" :style="clockBackgroundStyle">
      <div id="clock-text">{{ time }}</div>
    </div>
  </v-card>
</template>


<script>
export default {
  data: () => ({
    currentAngle: 0,
    timer: null,
    time: '???',
  }),
  computed: {
    clockBackgroundStyle() {
      return {
        background: `conic-gradient(gray 0deg ${this.currentAngle}deg, #2d3436 ${this.currentAngle}deg 360deg)`,
      };
    },
  },
  mounted() {
    this.updateAngle(); // call once immediately

    // Calculate milliseconds until the next exact minute
    const now = new Date();
    const delayToNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    // Align to next minute
    setTimeout(() => {
      this.updateAngle(); // run at the start of the next minute

      // Then run every 60 seconds
      this.timer = setInterval(this.updateAngle, 60000);
    }, delayToNextMinute);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    updateAngle() {
      const now = new Date();
      const hour = now.getHours();
      const minute = now.getMinutes();
      let totalMinutes = hour * 60 + minute;
      if(totalMinutes > 720) totalMinutes -= 720; // minus 12 hours after noon
      this.currentAngle = (totalMinutes / 720) * 360; // 720 = 12*60
      this.time = this.$moment().format('hh:mm A');
    },
  },
};
</script>

<style scoped>
#clock-background {
  border-radius: 30px;
  margin: 4px;
  height: 52px;
  width: 52px;
}

#clock-text {
  font-size: 10px;
  color: white;
}
</style>